var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSphereLayer3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 371"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-layer-3_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-layer-3_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487FCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-layer-3_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E4FA",
    offset: "98.567%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-.8%",
    y: "-24%",
    width: "101.6%",
    height: "148%",
    filterUnits: "objectBoundingBox",
    id: "sphere-layer-3_svg__d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23.1%",
    y: "-23.1%",
    width: "146.2%",
    height: "146.2%",
    filterUnits: "objectBoundingBox",
    id: "sphere-layer-3_svg__e"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-5.7%",
    y: "-12%",
    width: "111.3%",
    height: "124%",
    filterUnits: "objectBoundingBox",
    id: "sphere-layer-3_svg__f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-layer-3_svg__a)",
    opacity: 0.752,
    x: 15,
    width: 317,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-layer-3_svg__b)",
    opacity: 0.542,
    x: 101,
    y: 364,
    width: 164,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 306.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-layer-3_svg__c)",
    opacity: 0.063,
    filter: "url(#sphere-layer-3_svg__d)",
    y: 11.992,
    width: 768,
    height: 25,
    rx: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    opacity: 0.782,
    filter: "url(#sphere-layer-3_svg__e)",
    cx: 760,
    cy: 25.992,
    r: 13
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#00030A",
    strokeWidth: 3,
    opacity: 0.778,
    filter: "url(#sphere-layer-3_svg__f)",
    x: 683.5,
    y: 2.492,
    width: 103,
    height: 47,
    rx: 23.5
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgSphereLayer3 as ReactComponent };